import React, { useState } from 'react'

import { usePet } from '../../modules'
import Confirm from '../resusable/confirm'

import Modal from "../resusable/modal"

const Void = ({ toggle, visible, order, onPerform }) => {
    const [reason, setReason] = useState()

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Bill has been voided', ops('success'))        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('toggleVoidBill', {
        id: order?._id,
        reason
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Voiding this bill...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Void Bill"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Reason
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-notes"
                        rows="4"
                        value={ reason }
                        onChange={ e => setReason(e.target.value)}
                        placeholder="Incase of returns, include person who received the items" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading || reason?.length < 5 } onClick={ () => reason?.length >= 5 && Confirm({
                    title: 'Void This Bill',
                    message: 'Please confirm before performing this action',
                    okText: 'Void Bill',
                    onOk: execute
                }) } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Void Bill</button>
            </div>
        </Modal>
    )
}

export default Void